module.exports = __webpack_public_path__ + "img/imgfaqs.2cefc78a.jpeg";